import styled from 'styled-components';
const S = {};

S.NoActiveProviders = styled.div`
  width: 100%;
  font-size: 1rem;
  text-align: center;
`;

export default S;